/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {RootState} from '../../../redux/store'
import {toAbsoluteUrl} from '../../../template/_metronic/helpers'

const HeaderUserMenu: FC = () => {
  const currentUser = useSelector((state: RootState) => state.authSlice.user)
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/soyfri-media/profile-image.png')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder text-primary-dark d-flex align-items-center fs-5'>
              {currentUser?.name}
            </div>
            <a href='#' className='fw-bold text-muted text-break text-hover-primary fs-7'>
              {currentUser?.emailAddress}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to='/logout' className='menu-link px-5'>
          Cerrar sesión
        </Link>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
